// Shared rich-text HTML sanitizer for blog/article body content.
//
// Uses sanitize-html (a pure-JS parser, no DOM/browser APIs involved) rather than DOMPurify —
// see NevTan Sign's src/utils/sanitizeHtml.js for the fuller reasoning (DOMPurify needs a real
// DOM to sanitize against, which is awkward under SSR; this runs identically anywhere). This
// app has no SSR at all, but the same sanitizer is kept for parity with the ported blog stack
// and because it needs no DOM to run, which keeps it usable from a future build-time prerender
// step too.
import sanitizeHtmlLib from 'sanitize-html'

const ALLOWED_TAGS = [
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'br', 'strong', 'b', 'em', 'i', 'u', 's',
  'ul', 'ol', 'li', 'a', 'img', 'table', 'thead', 'tbody', 'tr', 'th', 'td', 'span',
  'div', 'blockquote', 'pre', 'code', 'hr', 'figure', 'figcaption',
]

const ALLOWED_ATTRIBUTES: sanitizeHtmlLib.IOptions['allowedAttributes'] = {
  '*': ['class', 'style', 'title'],
  a: ['href', 'target', 'rel'],
  img: ['src', 'alt', 'width', 'height'],
}

const ALLOWED_SCHEMES = ['http', 'https', 'mailto', 'tel', 'callto', 'cid', 'xmpp']

export function sanitizeRichHtml(html?: string | null): string {
  return sanitizeHtmlLib(html || '', {
    allowedTags: ALLOWED_TAGS,
    allowedAttributes: ALLOWED_ATTRIBUTES,
    allowedSchemes: ALLOWED_SCHEMES,
    allowProtocolRelative: true,
  })
}
